/* EcoYoung: Do koszyka z karty na stronie kategorii (14.10.2026, makiety 7b/8b).
   Osobny plik obok ey-kolekcja.js (filtry, Pokaz wiecej), zeby logika koszyka byla w jednym miejscu. */
(function () {
  function track(name, data) {
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }
  function init(root) {
    if (root.__eykQa) return; root.__eykQa = true;
    var sid = root.getAttribute('data-section');
    var grid = root.querySelector('[data-eyk-grid]');
    if (!grid) return;
    /* ---------- Do koszyka z karty (14.10.2026, makiety 7b/8b) ----------
       Klik na przycisku karty: produkt z jednym wariantem idzie prosto do koszyka, reszta otwiera okno
       wyboru (komputer: okno na srodku, telefon: arkusz od dolu). Dane to REALNE warianty z
       sections/ey-quick-data.liquid (ID, cena, dostepnosc, zdjecie wariantu, probki kolorow).
       Delegacja na siatce, wiec dziala tez na kartach doladowanych przyciskiem Pokaz wiecej. */
    var qd = root.querySelector('[data-eyk-qd]');
    var qbox = root.querySelector('[data-eyk-qd-box]');
    var qCache = {};
    var q = null;
    var TT = (root.getAttribute('data-tt') || '').split('|').map(function (n) { return parseInt(n, 10); });
    if (TT.length < 6 || TT.some(isNaN)) TT = [2, 4, 3, 5, 1, 2];
    var CUT = parseInt(root.getAttribute('data-cut'), 10);
    var MONTHS = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
    var ICO_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var ICO_OK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#3f6b35" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg>';
    var ICO_CLK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#6e4220" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>';
    var ICO_CH = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function warsawNow() {
      try {
        var g = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
          .formatToParts(new Date()).forEach(function (p) { g[p.type] = p.value; });
        var h = parseInt(g.hour, 10); if (h === 24) h = 0;
        return new Date(parseInt(g.year, 10), parseInt(g.month, 10) - 1, parseInt(g.day, 10), h, parseInt(g.minute, 10));
      } catch (e) { return new Date(); }
    }
    function isWeekend(d) { var x = d.getDay(); return x === 0 || x === 6; }
    function startDay() {
      var d = warsawNow();
      var move = (!isNaN(CUT) && d.getHours() >= CUT) || isWeekend(d);
      d.setHours(0, 0, 0, 0);
      if (move) { do { d.setDate(d.getDate() + 1); } while (isWeekend(d)); }
      return d;
    }
    function addBD(date, n) {
      var d = new Date(date.getTime()), added = 0;
      while (added < n) { d.setDate(d.getDate() + 1); if (!isWeekend(d)) added++; }
      return d;
    }
    function range(fast) {
      var s1 = fast ? TT[0] : TT[2], s2 = fast ? TT[1] : TT[3];
      var base = startDay();
      var a = addBD(base, s1 + TT[4]), b = addBD(base, s2 + TT[5]);
      if (a.getMonth() === b.getMonth()) return a.getDate() === b.getDate() ? a.getDate() + ' ' + MONTHS[a.getMonth()] : a.getDate() + '–' + b.getDate() + ' ' + MONTHS[a.getMonth()];
      return a.getDate() + ' ' + MONTHS[a.getMonth()] + ' – ' + b.getDate() + ' ' + MONTHS[b.getMonth()];
    }

    function fetchData(url) {
      if (qCache[url]) return qCache[url];
      qCache[url] = fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=ey-quick-data', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var s = doc.querySelector('script[data-eyq]');
          if (!s) throw new Error('brak danych');
          var d = JSON.parse(s.textContent);
          d.ci = -1;
          d.opts.forEach(function (o, i) {
            if (o.c && d.ci < 0) d.ci = i;
            /* opcje inne niz kolor od najtanszej (makieta: 120 x 90 przed 140 x 90) */
            if (!o.c) {
              var minP = function (n) { var m = Infinity; d.vs.forEach(function (v) { if (v.o[i] === n && v.p < m) m = v.p; }); return m; };
              o.v = o.v.map(function (x, k) { return { x: x, k: k, p: minP(x.n) }; }).sort(function (a, b) { return a.p - b.p || a.k - b.k; }).map(function (z) { return z.x; });
            }
          });
          return d;
        });
      qCache[url].catch(function () { delete qCache[url]; });
      return qCache[url];
    }

    function findV(d, sel) {
      for (var i = 0; i < d.vs.length; i++) {
        var v = d.vs[i], ok = true;
        for (var k = 0; k < sel.length; k++) { if (v.o[k] !== sel[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function colorVal(d, name) {
      if (d.ci < 0) return null;
      var vals = d.opts[d.ci].v;
      for (var i = 0; i < vals.length; i++) if (vals[i].n === name) return vals[i];
      return null;
    }
    function isFastV(d, v) { if (d.ci < 0) return true; var cv = colorVal(d, v.o[d.ci]); return !cv || cv.f; }
    /* najlepszy dostepny wariant spelniajacy warunek: najpierw kolor szybki, potem najnizsza cena */
    function best(d, pred, keep) {
      var list = d.vs.filter(function (v) { return v.a && pred(v); });
      if (!list.length) return null;
      list.sort(function (x, y) {
        var kx = 0, ky = 0;
        if (keep) for (var k = 0; k < keep.length; k++) { if (keep[k] != null) { if (x.o[k] === keep[k]) kx++; if (y.o[k] === keep[k]) ky++; } }
        if (kx !== ky) return ky - kx;
        var fx = isFastV(d, x) ? 0 : 1, fy = isFastV(d, y) ? 0 : 1;
        if (fx !== fy) return fx - fy;
        return x.p - y.p;
      });
      return list[0];
    }

    function plural(n, a, b, c) { if (n === 1) return a; var x = n % 10, y = n % 100; return x >= 2 && x <= 4 && (y < 12 || y > 14) ? b : c; }

    function swHtml(d, oi, val, named) {
      var on = q.sel[oi] === val.n;
      var probe = q.sel.slice(); probe[oi] = val.n;
      var exact = findV(d, probe);
      var any = d.vs.some(function (v) { return v.a && v.o[oi] === val.n; });
      var na = !exact || !exact.a;
      var st = val.sw ? 'background-image:url(' + esc(val.sw) + ')' : (val.col ? 'background-color:' + esc(val.col) : '');
      var txt = !val.sw && !val.col;
      var b = '<button type="button" class="eyk-qd__sw' + (txt ? ' eyk-qd__sw--txt' : '') + (on ? ' is-on' : '') + (na ? ' is-na' : '') + '" data-q-opt="' + oi + '" data-q-val="' + esc(val.n) + '" data-k="o' + oi + '-' + esc(val.n) + '" aria-pressed="' + on + '" aria-label="' + esc(val.n) + (any ? '' : ', niedostępny') + '" title="' + esc(val.n) + '"' + (any ? '' : ' disabled') + ' style="' + st + '">' + (txt ? esc(val.n) : '') + '</button>';
      return named && !txt ? '<span class="eyk-qd__swn">' + b + '<small>' + esc(val.n) + '</small></span>' : b;
    }

    function render(focusKey) {
      var d = q.d, v = findV(d, q.sel);
      var img = (v && v.img) || d.img;
      var price = v ? v.pf : '';
      var href = d.u + (v ? (d.u.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id : '');
      var h = '';
      h += '<div class="eyk-qd__media"><span class="eyk-qd__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="360" height="360">' : '') + '</span>';
      h += '<a class="eyk-qd__more" href="' + esc(href) + '" data-q-more>Pełny opis, wymiary i dodatki</a></div>';
      h += '<div class="eyk-qd__main"><span class="eyk-qd__grab" aria-hidden="true"></span>';
      h += '<button type="button" class="eyk-qd__x" data-q-close aria-label="Zamknij">' + ICO_X + '</button>';
      h += '<div class="eyk-qd__head"><span class="eyk-qd__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="68" height="68">' : '') + '</span>';
      h += '<span class="eyk-qd__ht"><span class="eyk-qd__t" id="EykQdT-' + esc(sid) + '">' + esc(d.t) + '</span><span class="eyk-qd__p" aria-live="polite">' + esc(price) + '</span></span></div>';
      h += '<div class="eyk-qd__body">';
      /* kolejnosc jak na makiecie: najpierw rozmiar (i inne opcje), na koncu kolor */
      var order = d.opts.map(function (o, oi) { return oi; }).sort(function (a, b) { return (d.opts[a].c ? 1 : 0) - (d.opts[b].c ? 1 : 0) || a - b; });
      order.forEach(function (oi) {
        var o = d.opts[oi];
        if (o.v.length < 2) return;
        if (o.c) {
          var fast = o.v.filter(function (x) { return x.f; }), rest = o.v.filter(function (x) { return !x.f; });
          var selFast = true;
          var cur = colorVal(d, q.sel[oi]);
          if (cur && !cur.f) selFast = false;
          h += '<div class="eyk-qd__grp"><span class="eyk-qd__lbl"><b>' + esc(o.n) + ':</b> ' + esc(q.sel[oi] || '') + '</span>';
          var anyTxt = o.v.some(function (x) { return !x.sw && !x.col; });
          h += '<div class="eyk-qd__sws' + (anyTxt ? ' eyk-qd__sws--txt' : '') + '">' + fast.map(function (x) { return swHtml(d, oi, x, false); }).join('') + '</div>';
          var lead = d.fab ? (selFast ? 'Te kolory szyjemy najszybciej. ' : 'Kolor na zamówienie. ') : '';
          h += '<p class="eyk-qd__eta"><span class="eyk-qd__eta-i' + (selFast ? '' : ' is-order') + '">' + (selFast ? ICO_OK : ICO_CLK) + '</span><span>' + esc(lead) + 'U Ciebie <b>' + esc(range(d.fab ? selFast : false)) + '</b>.</span></p>';
          if (rest.length) {
            var open = !!q.more;
            h += '<button type="button" class="eyk-qd__morec" data-q-morec data-k="morec" aria-expanded="' + open + '">+' + rest.length + ' ' + plural(rest.length, 'kolor', 'kolory', 'kolorów') + ' na zamówienie' + ICO_CH + '</button>';
            h += '<div class="eyk-qd__rest' + (anyTxt ? ' eyk-qd__sws--txt' : '') + '"' + (open ? '' : ' hidden') + '>' + rest.map(function (x) { return swHtml(d, oi, x, true); }).join('') + '</div>';
          }
          h += '</div>';
        } else {
          h += '<div class="eyk-qd__grp"><span class="eyk-qd__lbl"><b>' + esc(o.n) + ':</b> ' + esc(q.sel[oi] || '') + '</span>';
          h += '<div class="eyk-qd__sizes" style="--n:' + Math.min(o.v.length, 3) + '">';
          o.v.forEach(function (x) {
            var probe = q.sel.slice(); probe[oi] = x.n;
            var pv = findV(d, probe);
            if (!pv || !pv.a) pv = best(d, function (vv) { return vv.o[oi] === x.n; }, probe) || pv;
            var avail = d.vs.some(function (vv) { return vv.a && vv.o[oi] === x.n; });
            var on = q.sel[oi] === x.n;
            h += '<button type="button" class="eyk-qd__size' + (on ? ' is-on' : '') + '" data-q-opt="' + oi + '" data-q-val="' + esc(x.n) + '" data-k="o' + oi + '-' + esc(x.n) + '" aria-pressed="' + on + '"' + (avail ? '' : ' disabled') + '><span class="eyk-qd__sl">' + esc(x.n) + '</span><span class="eyk-qd__sp">' + (avail ? esc(pv ? pv.pf : '') : 'niedostępny') + '</span></button>';
          });
          h += '</div></div>';
        }
      });
      h += '</div>';
      h += '<div class="eyk-qd__foot">';
      if (v && v.a) h += '<button type="button" class="eyk-qd__cta" data-q-add data-k="add">Dodaj do koszyka · ' + esc(price) + '</button>';
      else h += '<button type="button" class="eyk-qd__cta" disabled>Chwilowo niedostępny</button>';
      h += '<p class="eyk-qd__err" role="alert" hidden></p>';
      h += '<a class="eyk-qd__more2" href="' + esc(href) + '" data-q-more>Zobacz pełny opis, wymiary i dodatki</a></div>';
      h += '</div>';
      qbox.innerHTML = h;
      if (focusKey) {
        var f = qbox.querySelector('[data-k="' + focusKey.replace(/"/g, '\\"') + '"]');
        if (f) f.focus();
      }
    }

    function pick(oi, val) {
      var d = q.d;
      var sel = q.sel.slice(); sel[oi] = val;
      var v = findV(d, sel);
      if (!v || !v.a) {
        var b2 = best(d, function (vv) { return vv.o[oi] === val; }, sel);
        if (b2) sel = b2.o.slice();
      }
      q.sel = sel;
      var cv = colorVal(d, sel[d.ci]);
      if (cv && !cv.f) q.more = true;
      render('o' + oi + '-' + val);
    }

    function setBusy(b, on) { if (!b) return; if (on) { b.setAttribute('aria-busy', 'true'); b.classList.add('is-busy'); } else { b.removeAttribute('aria-busy'); b.classList.remove('is-busy'); } }

    function addToCart(id) {
      var cn = document.querySelector('cart-notification');
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      if (cn && typeof cn.getSectionsToRender === 'function') {
        fd.append('sections', cn.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', location.pathname);
      }
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootUrl + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw res;
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'eyk-quick', productVariantId: id, cartData: res }); } catch (e) {}
          }
          if (cn && res.sections && typeof cn.renderContents === 'function') {
            document.documentElement.classList.add('eyk-notif-fix');
            cn.renderContents(res);
          } else {
            location.href = rootUrl + 'cart';
          }
          return res;
        });
    }
    function errText(err) { return (err && (err.description || err.message)) || 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.'; }

    function closeQ() { if (qd && qd.open) qd.close(); }
    if (qd) {
      qd.addEventListener('close', function () {
        document.documentElement.classList.remove('eyk-qd-open');
        if (q && q.btn) q.btn.classList.remove('is-on');
      });
      qd.addEventListener('click', function (e) {
        if (e.target === qd) { closeQ(); return; }
        var t = e.target.closest('button, a');
        if (!t || !q) return;
        if (t.hasAttribute('data-q-close')) { closeQ(); return; }
        if (t.hasAttribute('data-q-opt')) { pick(parseInt(t.getAttribute('data-q-opt'), 10), t.getAttribute('data-q-val')); return; }
        if (t.hasAttribute('data-q-morec')) { q.more = t.getAttribute('aria-expanded') !== 'true'; render('morec'); return; }
        if (t.hasAttribute('data-q-more')) { track('eyk_quick_pdp', { eyk_produkt: q.d.t }); return; }
        if (t.hasAttribute('data-q-add')) {
          var v = findV(q.d, q.sel);
          if (!v || !v.a || t.getAttribute('aria-busy') === 'true') return;
          setBusy(t, true);
          var errEl = qbox.querySelector('.eyk-qd__err');
          if (errEl) errEl.hidden = true;
          addToCart(v.id).then(function () {
            track('eyk_quick_add', { eyk_produkt: q.d.t, eyk_wariant: String(v.id), eyk_opcje: v.o.join(' / '), eyk_cena: v.p / 100, eyk_tryb: 'okno' });
            closeQ();
          }).catch(function (err) {
            setBusy(t, false);
            if (errEl) { errEl.textContent = errText(err); errEl.hidden = false; }
            track('eyk_quick_blad', { eyk_produkt: q.d.t, eyk_blad: errText(err) });
          });
        }
      });
    }

    function openQ(btn, d) {
      var b0 = best(d, function () { return true; });
      var sel = (b0 || d.vs[0]).o.slice();
      q = { d: d, sel: sel, btn: btn, more: false };
      var cv = colorVal(d, sel[d.ci]);
      if (cv && !cv.f) q.more = true;
      render();
      btn.classList.add('is-on');
      document.documentElement.classList.add('eyk-qd-open');
      if (qd.showModal) qd.showModal(); else qd.setAttribute('open', '');
      var first = qbox.querySelector('.eyk-qd__size.is-on, .eyk-qd__sw.is-on, [data-q-add]');
      if (first) first.focus();
      track('eyk_quick_open', { eyk_produkt: d.t });
    }

    function direct(btn, id, title) {
      setBusy(btn, true);
      addToCart(id).then(function (res) {
        setBusy(btn, false);
        track('eyk_quick_add', { eyk_produkt: title, eyk_wariant: String(id), eyk_cena: res && res.price ? res.price / 100 : undefined, eyk_tryb: 'bezposrednio' });
      }).catch(function (err) {
        setBusy(btn, false);
        track('eyk_quick_blad', { eyk_produkt: title, eyk_blad: errText(err) });
        location.href = btn.getAttribute('data-url');
      });
    }

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-eyk-qa]');
      if (!btn || !grid.contains(btn)) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      var url = btn.getAttribute('data-url'), title = btn.getAttribute('data-title') || '';
      var vid = btn.getAttribute('data-variant');
      if (vid) { direct(btn, vid, title); return; }
      if (!qd || !qbox) { location.href = url; return; }
      setBusy(btn, true);
      fetchData(url).then(function (d) {
        setBusy(btn, false);
        var avail = d.vs.filter(function (v) { return v.a; });
        if (d.vs.length === 1 && avail.length === 1) { direct(btn, avail[0].id, d.t); return; }
        if (!avail.length) { location.href = url; return; }
        openQ(btn, d);
      }).catch(function () { setBusy(btn, false); location.href = url; });
    });
    /* dane pobieramy juz przy najezdzie albo dotyku, zeby okno otwieralo sie bez czekania */
    function warm(e) {
      var btn = e.target.closest && e.target.closest('[data-eyk-qa]');
      if (btn && !btn.getAttribute('data-variant')) fetchData(btn.getAttribute('data-url')).catch(function () {});
    }
    grid.addEventListener('pointerover', warm);
    grid.addEventListener('touchstart', warm, { passive: true });
    grid.addEventListener('focusin', warm);
  }
  function boot() { document.querySelectorAll('[data-eyk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
